import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
    isLoading: false,
    error: null,
    networkItems: [],
};

const networkSlice = createSlice({
    name: 'network',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        getNetworkSuccess(state, action) {
            state.isLoading = false;
            state.networkItems = action.payload;
        },
    },
});

export default networkSlice.reducer;

export const { startLoading, hasError, getNetworkSuccess } = networkSlice.actions;

export const getAllNetworks = () => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.get('attributes/network/get-all-network');
        dispatch(getNetworkSuccess(response?.data?.data));
    } catch (error) {
        dispatch(hasError(error));
    }
};

export const addNetwork = (network) => async (dispatch) => {
    dispatch(startLoading());
    try {
        const currentUser = JSON.parse(localStorage.getItem('currentuser'));
        const response = await axios.post('attributes/network/network-add', {
            Network: network,
            AddedBy: `${currentUser?.firstName} ${currentUser?.lastName}`,
        })
        dispatch(getAllNetworks());
        return response;
    } catch (error) {
        dispatch(hasError(error));
        return error;
    }
};

export const deleteNetwork = (id) => async (dispatch) => {
    dispatch(startLoading());
    try {
        await axios.delete(`attributes/network/network-delete/${id}`);
        dispatch(getAllNetworks());
    } catch (error) {
        dispatch(hasError(error));
    }
};

export const updateNetwork = (network, id) => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.put(`attributes/network/network-update/${id}`, {
            Network: network
        });
        dispatch(getAllNetworks());
        return response;
    } catch (error) {
        dispatch(hasError(error));
    }
};